
import { Search, Field } from 'vant'
import {AMap, jsSdk} from '../../../assets/libs/loadjs';
import { checkBrowser } from '../../../assets/js/xjpublic';
import { errorModal } from '../../../assets/js/xjcommon';

export default {
  name: 'home',
  components: {
    [Search.name]: Search,
    [Field.name]: Field,
  },
  data () {
    return {
      // 地图相关
      // 地图中心坐标(也是用户选择的坐标)
      mapCenter: [104.065755, 30.657555],
      mapZoom: 3,
      mapIcon: require('../../../assets/images/map/ic_redcar.png'),
      mapIconOne: require('../../../assets/images/map/ic_user_location.png'),
      // 用户输入的关键字
      bdSearchPlace: '',
      // 用户选择的地址
      searchPlace: '',
      // 预约成功的坐标(避免重复提交)
      sendSuccessPoint: [],
      // 地图是否加载(用于显示页面上的搜索框)
      loadingMap: true,
      // 是否是第一次加载地图(解决首次加载执行两次positionPicker on方法的问题,应该是会默认移动一下)
      firstLoadingMap: true,
      // 接人状态
      pickupState: 1,
      // 设备状态
      deviceStatus: 0,
      // 上一次车辆的位置
      carLocation: [0, 0, 0],
      useImei: '',
      // 分享链接有效期(小时)(不用)
      maxHours: 24,
      // 权限开放
      accessToken: '',
      expiresTime: '',
      // 检查显示地址的节点是否加载
      checkAddressTextTimes: 0,
      setIntervalCheckAddressText: null,
      // 定时更新车辆位置
      setIntervalCarInfo: null,
      intervalTime: 10000,
    }
  },
  methods: {
    // 拖拽选址 + 搜素功能
    initReserveMap () {
      this.loadingMap = false;
      let _this = this;
      AMapUI.loadUI(['misc/PositionPicker', 'misc/PoiPicker'], function(PositionPicker, PoiPicker) {
        // part one 初始化地图 ===============
        let map = new AMap.Map('reserve-map', {
          // 地图中心点坐标值
          center: _this.mapCenter,
          // 地图显示的缩放级别
          zoom: _this.mapZoom,
          // 是否可通过鼠标滚轮缩放浏览，默认为true
          scrollWheel: false,
          // 地图是否可通过鼠标拖拽平移，默认为true
          // dragEnable: false,
          // 地图是否使用缓动效果，默认值为true
          jogEnable: false
        });

        // xj edit start
        // 判断是否过期
        let btnText = '发送位置';
        if ((new Date()).valueOf() > _this.expiresTime) {
          btnText = '链接已过期'
        }
        // 信息窗口
        let title = '设备：<span style="color: #007aff;">' + (_this.useImei || '未获取到对方设备') + '</span>';
        let content = [
          '<div style="background-color: #ffffff;padding-top: 5px;border-radius: 5px;color: #333333;min-width: 300px;">' +
          '<p style="padding: 1px 0;">地址：<span id="search-address-text"></span></p>' +
          '<div style="width: 100%;"><label id="reserveBtn" style="display: inline-block;width: 101%;margin: 8px 0 3px 1%;padding:8px 0;text-align: center;background-color: #007aff;color: #ffffff;border-radius: 4px;">' + btnText + '</label></div>' +
          '</div>'
        ];
        // 通过事件委托解决点击事件
        let fatherDiv = document.getElementById('reserve-map');
        fatherDiv.onclick = function (e) {
          // 判断事件源是不是reserveBtn
          if (e.target.nodeName.toLowerCase() === 'label') {
            _this.reserveNavigationFn();
          }
        };
        // 实现自定义窗体内容，返回拼接后的字符串
        function createInfoWindow (title, content) {
          // 内容拼接 ...
          return title + content;
        }
        // 创建 infoWindow 实例
        let infoWindow = new AMap.InfoWindow({
          isCustom: false,  // 是否使用自定义窗体
          anchor: 'bottom-center', // 默认值：'bottom-center'
          content: createInfoWindow(title, content.join('<br>')),  // 传入dom对象，或者html字符串
          offset: new AMap.Pixel(0, -30), // 信息窗体显示位置偏移量
          closeWhenClickMap: true, // 是否在鼠标点击地图后关闭信息窗体，默认false
          showShadow: false, // 是否显示信息窗体阴影默认值：false
          // size: ''
        });
        // 下面两行是用于poiPickerReady方法中(搜索之后)
        window.infoWindow = infoWindow;
        window.map = map;
        // 信息窗体打开
        infoWindow.open(map, _this.mapCenter);
        // 监听地图的点击事件
        AMap.event.addListener(map, 'click', function () {
          infoWindow.open(map, _this.mapCenter);
        });
        // 监听地图的移动事件
        AMap.event.addListener(map, 'mapmove', function () {
          infoWindow.close();
        });
        // xj edit end

        // part two 拖拽选址 ===============
        let positionPicker = new PositionPicker({
          mode: 'dragMap',
          map: map
        });
        // 地图拖拽之后
        positionPicker.on('success', function(positionResult) {
          // console.log(positionResult);
          if (_this.firstLoadingMap) {
            _this.firstLoadingMap = false;
            return;
          }
          // 将当前坐标点和地址信息显示到页面
          // 显示地址,首次(定位之后)可能出现addressText未加载完成的问题
          let addressText = document.querySelector('#search-address-text');
          // _this.checkAddressTextFn(addressText, positionResult.address);
          if (addressText) {
            addressText.innerHTML = positionResult.address;
          } else {
            setTimeout(function () {
              addressText = document.querySelector('#search-address-text');
              addressText.innerHTML = positionResult.address;
            },1000);
          }
          // 重新打开窗口
          infoWindow.open(map, [positionResult.position.lng, positionResult.position.lat]);
          // 保存当前坐标点和地址信息
          _this.mapCenter = [positionResult.position.lng, positionResult.position.lat];
          _this.searchPlace = positionResult.address;
        });
        positionPicker.on('fail', function() {
          let addressText = document.querySelector('#search-address-text');
          addressText.innerHTML = '获取地址信息失败';
          _this.mapCenter = [];
          _this.searchPlace = '';
        });

        positionPicker.start();
        map.panBy(0, 1);

        map.addControl(new AMap.ToolBar({
          liteStyle: true
        }));

        // part there 输入框选择POI点 ===============
        let poiPicker = new PoiPicker({
          // city:'北京',
          input: 'picker-input',
          map: map
        });
        // 初始化poiPicker
        poiPickerReady(poiPicker);
      });
      // 搜索选择POI点
      function poiPickerReady (poiPicker) {
        // window.poiPicker = poiPicker;
        // 选取了某个POI
        poiPicker.on('poiPicked', function(poiResult) {
          // console.log(poiResult);
          // 这里只需要重新打开窗口，地图会自动更新?
          // 将当前坐标点和地址信息显示到页面
          // let addressText = document.querySelector('#search-address-text');
          // addressText.innerHTML = poiResult.item.district + '（' + poiResult.item.name + '）';
          // 重新打开窗口
          infoWindow.open(map, [poiResult.item.location.lng, poiResult.item.location.lat]);
          // 保存当前坐标点和地址信息
          // _this.mapCenter = [poiResult.item.location.lng, poiResult.item.location.lat];
          // _this.searchPlace = poiResult.item.district + '（' + poiResult.item.name + '）';
        });
        // 初始化搜索(这里不用)
        // poiPicker.onCityReady(function() {
        //   poiPicker.suggest('美食');
        // });
      }
    },
    // 显示车辆位置
    showCarFn (lon, lat, direct) {
      if (this.carLocation[0] === lon && this.carLocation[1] === lat && this.carLocation[2] === direct) {
        return
      }
      this.carLocation = [lon, lat, direct];
      let _this = this;
      let map = new AMap.Map('reserve-map', {
        center: this.mapCenter,
        resizeEnable: true,
        zoom: this.mapZoom
      });
      // xj edit start
      // 计算距离
      let dis = AMap.GeometryUtil.distance(_this.sendSuccessPoint, [lon, lat]);
      let disText = (parseInt(dis) > 1000 ? (dis / 1000).toFixed(2) + '千' : parseInt(dis)) + '米';
      if (dis < 10) {
        this.cancelFn();
        this.$dialog({
          message: '车辆已到达目的地附件，请注意查看'
        });
        return;
      }
      // mark
      let markerOne = new AMap.Marker({
        position: new AMap.LngLat(_this.sendSuccessPoint[0], _this.sendSuccessPoint[1]),  // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        title: '点击查看详情',
        offset: new AMap.Pixel(-30, -30),
        icon: this.mapIconOne,
        angle: 0
      });
      // 将创建的点标记添加到已有的地图实例：
      map.add(markerOne);
      // 创建一个 Marker 实例：
      let markerTwo = new AMap.Marker({
        position: new AMap.LngLat(lon, lat),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        title: '点击查看详情',
        offset: new AMap.Pixel(-17, -30),
        icon: this.mapIcon,
        angle: direct || 0
      });
      // 将创建的点标记添加到已有的地图实例：
      map.add(markerTwo);
      // 信息窗口
      let devStatusText = this.deviceStatus === 1 ? '设备在线' : '设备离线';
      let devStatusColor = this.deviceStatus === 1 ? '#07c160' : '#ff0000';
      let title = '状态：<span style="color: ' + devStatusColor + ';">' + (devStatusText || '加载中') + '</span>';
      let content = [
        '<div style="background-color: #ffffff;padding-top: 5px;border-radius: 5px;color: #333333;">' +
        '<p style="padding: 1px 0;">状态：<span style="color: ' + devStatusColor + ';">' + (devStatusText || '加载中') + '</span></p>' +
        '<p style="padding: 1px 0;">距离：<span id="distance-text">' + disText + '</span></p>' +
        '</div>'
      ];
      // 实现自定义窗体内容，返回拼接后的字符串
      function createInfoWindow (title, content) {
        // 内容拼接 ...
        // return title + content;
        return content;
      }
      // 创建 infoWindow 实例
      let infoWindow = new AMap.InfoWindow({
        isCustom: false,  // 是否使用自定义窗体
        anchor: 'bottom-center', // 默认值：'bottom-center'
        content: createInfoWindow(title, content.join('<br>')),  // 传入dom对象，或者html字符串
        offset: new AMap.Pixel(0, -30), // 信息窗体显示位置偏移量
        closeWhenClickMap: true, // 是否在鼠标点击地图后关闭信息窗体，默认false
        showShadow: false, // 是否显示信息窗体阴影默认值：false
        // size: ''
      });
      // 信息窗体打开
      infoWindow.open(map, [lon, lat]);
      // 监听地图的点击事件
      AMap.event.addListener(map, 'click', function () {
        // infoWindow.open(map, _this.mapCenter);
      });
      AMap.event.addListener(markerTwo, 'click', function () {
        infoWindow.open();
      });
      // 监听地图的移动事件
      AMap.event.addListener(map, 'mapmove', function () {
        // infoWindow.close();
      });
      // 传入覆盖物数组，仅包括polyline和marker1的情况
      map.setFitView([markerOne,markerTwo]);
      // xj edit end
    },
    // 判断显示地址信息的节点是否加载(接人服务只是首次可能没加载完成)
    checkAddressTextFn (addressTextNode, showText) {
      if (this.checkAddressTextTimes < 10) {
        if (addressTextNode) {
          clearInterval(this.setIntervalCheckAddressText);
          addressTextNode.innerHTML = showText;
        } else {
          let _this = this;
          let setIntervalCheckAddressText = setInterval(function () {
            _this.checkAddressTextTimes++;
            _this.checkAddressTextFn(addressTextNode, showText);
          }, 500);
          this.setIntervalCheckAddressText = setIntervalCheckAddressText;
        }
      } else {
        clearInterval(this.setIntervalCheckAddressText);
        addressTextNode.innerHTML = showText;
      }
    },
    // 预约请求
    reserveNavigationFn () {
      // 判断是否过期
      if ((new Date()).valueOf() > this.expiresTime) {
        this.$dialog({
          message: '该链接已失效，请对方重新发送接人邀请'
        });
        return;
      }
      // 判断是否有设备号
      if (!this.useImei) {
        this.$dialog({
          message: '未获取到对方设备，请对方重新发送接人邀请'
        });
        return;
      }
      // 判断坐标点是否存在
      if (this.mapCenter.length === 0) {
        this.$dialog({
          message: '地址选择失败，请重新选择地址'
        });
        return;
      }
      // 判断是否已经预约成功
      if (this.sendSuccessPoint === this.mapCenter) {
        this.$dialog({
          message: '该地址已发送成功'
        });
        return;
      }
      let _this = this;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '发送中...'
      });
      this.$axios.post('/action/navigate', { type: 3, imei: this.useImei, gps: this.mapCenter })
        .then(function (response) {
          _this.loadingGetTripList = false;
          _this.$toast.clear();
          if (response.data.ret === 0) {
            _this.sendSuccessPoint = _this.mapCenter;
            // 关闭加载状态
            _this.$dialog({
              message: '发送成功'
            });
            _this.pickupState = 3;
            _this.getCarLocationFn();
            // 每10秒更新一次地图数据
            let setIntervalCarInfo = setInterval(function () {
              _this.getCarLocationFn();
            }, _this.intervalTime);
            _this.setIntervalCarInfo = setIntervalCarInfo;
            // 本地
            localStorage.setItem('xjWxPickupStatus', 3);
            localStorage.setItem('xjWxPickupAccessToken', _this.accessToken);
            localStorage.setItem('xjWxPickupLocation', _this.mapCenter);
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '发送失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 531);
        })
    },
    // 获取车辆位置
    getCarLocationFn () {
      let _this = this;
      this.$axios.post('/oauth/getVehicleInfo', {accessToken: this.accessToken})
        .then(function (response) {
          // console.log(response);
          // 关闭加载状态
          _this.$toast.clear();
          if (response.data.ret === 0) {
            let resData = response.data.data;
            _this.deviceStatus = resData.status;
            _this.showCarFn(resData.gps_data.lon,resData.gps_data.lat,resData.gps_data.direct);
          } else if (response.data.ret === 9) {
            // 登录过期
            _this.cancelFn();
          }else {
            _this.cancelFn();
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取车辆位置失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 532);
        })
    },
    // 取消
    cancelConfirmFn () {
      this.$dialog.confirm({
        title: '',
        message: '您确定要取消本次接人服务吗？',
        cancelButtonText: '再想想'
      }).then(() => {
        // on confirm
        this.cancelFn();
      }).catch(() => {
        // on cancel
      });
    },
    cancelFn () {
      clearInterval(this.setIntervalCarInfo);
      localStorage.setItem('xjWxPickupStatus', '');
      this.pickupState = 1;
      this.carLocation = [0, 0, 0];
      // 获取当前位置(同初始化)
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中...'
      });
      // 判断是否是微信
      if (checkBrowser.isWx()) {
        // 判断是否是ios系统
        if (checkBrowser.isIOS()) {
          this.getLocationGaoFn();
        } else {
          this.getLocationWxFn();
        }
      } else {
        this.getLocationGaoFn();
      }
    },
    // 高德地图定位(iso和网页浏览器可以,安卓不行)
    getLocationGaoFn () {
      let _this = this;
      let map = new AMap.Map('reserve-map', {
        zoom: _this.mapZoom,
        resizeEnable: true
      });
      AMap.plugin('AMap.Geolocation', function() {
        let geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,//是否使用高精度定位，默认:true
          timeout: 10000,          //超过10秒后停止定位，默认：5s
          buttonPosition:'RB',    //定位按钮的停靠位置
          buttonOffset: new AMap.Pixel(10, 20),  //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点

        });
        map.addControl(geolocation);
        geolocation.getCurrentPosition(function(status,result){
          if(status === 'complete'){
            onComplete(result)
          }else{
            onError(result)
          }
        });
      });
      //解析定位结果
      function onComplete(data) {
        console.log('高德地图定位成功');
        _this.mapCenter = [data.position.lng, data.position.lat];
        _this.mapZoom = 16;
        _this.initReserveMap();
        _this.$toast.clear();
      }
      //解析定位错误信息
      function onError(data) {
        console.log('高德地图定位失败');
        let cityCenter = map.getCenter();
        if (cityCenter && cityCenter.lng) {
          _this.mapCenter = [cityCenter.lng, cityCenter.lat];
        }
        _this.initReserveMap();
        _this.$toast.clear();
      }
    },
    // 微信定位(安卓可以,iso不行)
    getLocationWxFn () {
      let _this = this;
      jsSdk(this.$store.state.customer, ['getLocation']).then(function(){
        wx.getLocation({
          type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function (res) {
            console.log('微信定位成功');
            let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            _this.mapCenter = [longitude, latitude];
            _this.mapZoom = 16;
            _this.initReserveMap();
            _this.$toast.clear();
          },
          fail:function(res){
            console.log('微信定位失败');
            _this.initReserveMap();
            _this.$toast.clear();
            // _this.$notify({
            //   message: '微信定位失败',
            //   duration: 2500,
            //   background: '#ff3300'
            // })
          }
        });
      });
    },
  },
  mounted () {
    document.getElementById('reserve-map').style.height = window.screen.height;
    // 获取当前位置
    this.$toast.loading({
      mask: true,
      duration: 0,
      message: '加载中...'
    });
    this.useImei = this.$route.query.imei;
    this.expiresTime = parseInt(this.$route.query.time) || 0;
    this.accessToken = this.$route.query.token || '';
    // localStorage.removeItem('xjWxPickupStatus');
    // localStorage.removeItem('xjWxPickupAccessToken');
    if (localStorage.getItem('xjWxPickupStatus')) {
      this.pickupState = parseInt(localStorage.getItem('xjWxPickupStatus'));
      this.accessToken = localStorage.getItem('xjWxPickupAccessToken');
      this.sendSuccessPoint = localStorage.getItem('xjWxPickupLocation').split(',');
      this.getCarLocationFn();
      // 每10秒更新一次地图数据
      let _this = this;
      let setIntervalCarInfo = setInterval(function () {
        _this.getCarLocationFn();
      }, this.intervalTime);
      this.setIntervalCarInfo = setIntervalCarInfo;
      return;
    }
    // 判断是否是微信
    if (checkBrowser.isWx()) {
      // 判断是否是ios系统
      if (checkBrowser.isIOS()) {
        this.getLocationGaoFn();
      } else {
        this.getLocationWxFn();
      }
    } else {
      this.getLocationGaoFn();
    }
  },
  destroyed () {
    this.$notify.clear();
    clearInterval(this.setIntervalCarInfo);
  }
}
